export default {
  isLoading: false,
  banners: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  banner: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
  status: null
};
